import React from 'react'
import '../MRUOutcomes/style.scss'

function MRUBobTransferCreditsModal() {
	return (
		<div id="campus-life-modal" className="grid-12 c5 padd-top padd-bottom">
			<div className="span-12 padd-2 span-12-tablet">
				<div className="intro fs-125">
					<h2>Transfer Credits &amp; Prior Learning</h2>
				</div>
				<div className="grid-12 padd-top gap-1">
					<div className="container fs-85">
						<p className="padd-top">
							<strong>
								Transferability of Credits for the Bachelor of Science in Business and Healthcare
								Management Degree
							</strong>
						</p>
						<p>
							Policy on Accepting — Military Credits, Institutional Transfer Credits (TCs), &amp; Prior
							Learning Assessment (PLA)
						</p>
						<p>
							<strong>Accelerated Process — Bachelor of Business &amp; Healthcare Mgt.</strong>
						</p>

						<div className="table padd-top">
							<table>
								<tbody>
									<tr>
										<th style={{ backgroundColor: '#0c1c2c', textAlign: 'left' }} />
										<th style={{ backgroundColor: '#0c1c2c' }}>Semester Credits</th>
										<th style={{ backgroundColor: '#0c1c2c' }}>% of Program Requirements</th>
									</tr>
									<tr>
										<td style={{ textAlign: 'left' }}>Institutional Transfer and Military Credits</td>
										<td>up to 90</td>
										<td>up to 75%</td>
									</tr>
									<tr>
										<td style={{ textAlign: 'left' }}>Prior Learning Assessment (PLA) Credits</td>
										<td>up to 30</td>
										<td>up to 25%</td>
									</tr>
									<tr>
										<td style={{ textAlign: 'left' }}>
											Combination of Institutional Transfer, Military, and PLA Credits
										</td>
										<td>no more than 90</td>
										<td>no more than 75%</td>
									</tr>
									<tr>
										<td style={{ textAlign: 'left' }}>In Residence (must be completed at MRU)</td>
										<td>at least 30</td>
										<td>at least 25%</td>
									</tr>
									<tr>
										<td style={{ textAlign: 'left' }}>
											<strong>Total Program Credits</strong>
										</td>
										<td>
											<strong>120</strong>
										</td>
										<td>
											<strong>100%</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<ul className="padd-top">
							<li style={{ paddingBottom: '0.5rem' }}>
								Transfer in up to 75% of the qualifying credits needed for your bachelor&apos;s degree.
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Prior Learning Assessment (PLA) is a process that allows students to earn academic credit
								for knowledge and skills they&apos;ve gained outside of traditional classroom settings.
								The following are examples of what qualify for PLA:
								<ul style={{ paddingTop: '0.5rem' }}>
									<li style={{ paddingBottom: '0.35rem' }}>Military service and training</li>
									<li style={{ paddingBottom: '0.35rem' }}>Certifications and licenses</li>
									<li style={{ paddingBottom: '0.35rem' }}>
										Work experience and professional training / life experiences that demonstrate
										college-level learning through portfolio assessment. Students compile documentation
										and write reflective essays that demonstrate their learning. Meeting with the dean of
										the school of business to identify potential credit opportunities and map life
										experiences to specific course learning outcomes
									</li>
									<li style={{ paddingBottom: '0.35rem' }}>
										Challenge exams — standardized tests like CLEP, DSST, or institution-specific exams
									</li>
								</ul>
							</li>
							<li style={{ paddingBottom: '0.5rem' }}>
								Benefits: Faster degree completion, reduced tuition costs, recognition of valuable
								real-world learning, and increased motivation and confidence.
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MRUBobTransferCreditsModal
